import { useIsMobile } from '../hooks/use-is-mobile';
import { HELP_SECTIONS } from '@infrastructure/seed/dataset';

const sectionMap = Object.fromEntries(HELP_SECTIONS.map((s) => [s.title, s.body]));

interface HelpItem { title: string }
interface HelpGroup { label: string | null; items: HelpItem[]; wide?: boolean }

const GROUPS: HelpGroup[] = [
  {
    label: null,
    wide: true,
    items: [{ title: 'Tableau de bord' }],
  },
  {
    label: 'Modération',
    items: [{ title: 'Comptes entreprise' }, { title: 'Offres' }],
  },
  {
    label: 'Contenu',
    items: [{ title: 'Articles' }, { title: 'Suivi de grossesse' }, { title: 'Répertoire' }],
  },
  {
    label: 'Comptes',
    items: [{ title: 'Utilisatrices' }, { title: 'Rendez-vous' }, { title: 'Comptes admin' }],
  },
  {
    label: 'Paramètres & suivi',
    items: [
      { title: 'Entreprises · Performance' },
      { title: 'Formules & abonnements' },
      { title: 'Pays disponibles' },
      { title: 'Notifications' },
    ],
  },
  {
    label: 'Données de référence',
    items: [
      { title: 'Catégories articles' },
      { title: "Catégories d'offres" },
      { title: 'Motifs de rendez-vous' },
      { title: "Types d'entreprises" },
      { title: 'Catégories répertoire' },
    ],
  },
];

export function HelpPage(): JSX.Element {
  const isMobile = useIsMobile();

  return (
    <div style={{ maxWidth: 860, margin: '0 auto' }}>
      <p style={{ fontSize: 13.5, color: '#8A95A3', marginBottom: 24, lineHeight: 1.6 }}>
        Guide de prise en main — consultez cette page si vous cherchez comment utiliser un écran
        particulier.
      </p>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
          gap: isMobile ? 12 : 16,
          alignItems: 'start',
        }}
      >
        {GROUPS.map((group) => (
          <section
            key={group.label ?? 'home'}
            style={group.wide && !isMobile ? { gridColumn: '1 / -1' } : undefined}
          >
            {group.label ? (
              <div
                style={{
                  fontSize: 10.5,
                  fontWeight: 800,
                  letterSpacing: '0.09em',
                  textTransform: 'uppercase',
                  color: '#B0BAC4',
                  marginBottom: 8,
                }}
              >
                {group.label}
              </div>
            ) : null}

            <div className="bbm-card" style={{ padding: 0, overflow: 'hidden' }}>
              {group.items.map((item, i) => (
                <div
                  key={item.title}
                  style={{
                    padding: isMobile ? '12px 14px' : '14px 20px',
                    borderTop: i > 0 ? '1px solid #F0F2F5' : undefined,
                  }}
                >
                  <div
                    style={{
                      fontFamily: "'Baloo 2', sans-serif",
                      fontSize: 13.5,
                      fontWeight: 700,
                      color: '#1E3347',
                      marginBottom: 4,
                    }}
                  >
                    {item.title}
                  </div>
                  <p style={{ fontSize: 13, color: '#5A6370', lineHeight: 1.65, margin: 0 }}>
                    {sectionMap[item.title]}
                  </p>
                </div>
              ))}
            </div>
          </section>
        ))}
      </div>
    </div>
  );
}
